'use strict';

import Dot from './track/Dot';
import Dots from './track/Dots';
import Event from './track/Event';
import EventCustom from './track/EventCustom';
import InstructionsTranslator from './utils/InstructionsTranslator';

const FollowMeMapUtils = require('./FollowMeMapUtils');
const classifyPoint = require('robust-point-in-polygon');

/**
 *
 * @param querySelector
 * @param mapTypeObject
 * @constructor
 */
class FollowmeMap {
  constructor(querySelector, mapTypeObject) {
    this.map = new window.IWMap(document.querySelector(querySelector));

    const mapType = this.getMapType(mapTypeObject);

    const userConfig = FollowMeMapUtils.getUserConfig();

    mapType.setRenderingConfig(window.vectorMapConfig);
    mapType.setMaxLevel(18);

    this.map.setCenter(
      new window.IWCoordinate(
        userLocationCoordinates.longitude,
        userLocationCoordinates.latitude,
        'WGS84'
      ),
      userConfig.defaultZoomLevel ? userConfig.defaultZoomLevel : 17,
      mapType
    );

    this.routeRenderer = new window.IWMapRenderer(this.map);
    this.baseLinesRenderer = new window.IWMapRenderer(this.map);
    this.lineToMouseRenderer = new window.IWMapRenderer(this.map);
    this.statusAndRemarksRenderer = new window.IWMapRenderer(this.map);

    this.selectPolygonRenderer = new window.IWMapRenderer(this.map);
    this.selectPolygonActive = false;

    this.clickedCoordinates = [];

    // Consists objects with map dots/markers/event markers
    this.mapDots = new Dots();
    this.editingTracks = {};
    this.selectedDots = [-1];
    this.events = [];
    this.dayEvents = [];
    this.currentTrackVersion = -1;
    this.statusAndRemarks = {};
    this.staticTrackLines = null;

    this.undoStates = [];
    this.redoStates = [];

    this.moving = false;
    this.clicked = false;
    this.dragEnd = false;

    this.editingMode = false;
    this.caterpillarBigMoveKeyCode = 32;
    this.shiftKeyCode = 16;
    this.keysPressed = {};

    this.showRoute = false;
    this.showTrack = true;
    this.showEvents = true;
    this.showRouteInstructions = true;
    this.showStatusAndRemarks = true;
    this.showDayEvents = true;
    this.showAllEvents = true;

    this.routeData = {};

    this.swisstopoHybrid = '';
    this.swisstopoAir = '';

    this.liveViewPolylines = {};
    this.liveViewMarker = {};
    this.currentHighlightedTrack = 'no-track';

    this.MARKER_LAYOUT = 10;
    this.ROUTE_LAYOUT = 3;
    this.EVENT_MARKER_LAYOUT = 11;
    this.REMARKS_MARKER_LAYOUT = 12;
    this.DAY_EVENTS_LAYOUT = 13;
    this.SEARCH_MARKERS_LAYOUT = 14;
    this.INSTRUCTIONS_LAYOUT = 2;

    this.lineToMouseRenderer._drawingContainer.style['pointer-events'] = 'none';
    this.baseLinesRenderer._drawingContainer.style['pointer-events'] = 'none';
    this.routeRenderer._drawingContainer.style['pointer-events'] = 'none';
    this.statusAndRemarksRenderer._drawingContainer.style['pointer-events'] = 'none';

    this.markersContainer = $('#IWOverlay');
    this.traceControlsKeys();
    this.map.getOptions().setArrowKeyAction(window.IWMapOptions.CONTROL_NONE);

    this.pathStyles = {
      default: {
        main: {
          stroke: '#B5104F', strokeWidth: 5, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#fff', strokeWidth: 10, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      done: {
        main: {
          stroke: '#40b534', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#fff', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      todo: {
        main: {
          stroke: '#d9dd44', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#fff', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      missed: {
        main: {
          stroke: '#e63d3a', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#fff', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      ConnectError: {
        background: {
          stroke: '#FF0000', strokeWidth: 10, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        main: {
          stroke: '#FFF',
          strokeWidth: 5,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeDashStyle: 'dotted'
        }
      }
    };

    this.liveViewPathStyles = {
      default: {
        main: {
          stroke: '#B5104F', strokeWidth: 5, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#000', strokeWidth: 4, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      done: {
        main: {
          stroke: '#40b534', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#000', strokeWidth: 4, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      todo: {
        main: {
          stroke: '#e63d3a', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#000', strokeWidth: 4, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      missed: {
        main: {
          stroke: '#e63d3a', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#000', strokeWidth: 4, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      discarded: {
        main: {
          stroke: '#e63d3a', strokeWidth: 3, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        background: {
          stroke: '#000', strokeWidth: 4, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        }
      },
      ConnectError: {
        background: {
          stroke: '#FF0000', strokeWidth: 10, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
        },
        main: {
          stroke: '#000',
          strokeWidth: 5,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeDashStyle: 'dotted'
        }
      }
    };

    $(document).on('mouseenter', '.IWMarker', (event) => {
      $('<div>', {
        class: 'dot-information-container',
        text: i18next.t('general.dot-index-count', {
          index: $(event.currentTarget).data('index') + 1,
          total: this.mapDots.getTotalVisible()
        })
      }).appendTo($('body'));
    });

    $(document).on('mouseleave', '.IWMarker', () => {
      $('.dot-information-container').remove();
    });

    this.markersContainer.on('contextmenu', '.IWMarker', (event) => {
      event.stopPropagation();
      event.preventDefault();

      const contextMenu = window.createContextMenu(parseInt($(event.currentTarget).data('index'), 10));
      contextMenuMousePosition = window.getMousePosition(event);

      $('body').append(contextMenu);

      contextMenu.css({
        left: event.pageX + 'px',
        top: event.pageY + 'px'
      });

      contextMenu.show();
    });

    this.markersContainer.on('mousedown', '.IWMarker', (event) => {
      event.stopPropagation();

      const index = $(event.currentTarget).data('index');
      this.markerOnMouseDown(index, this.selectedDots.indexOf(index) !== -1, event);
    });
  }

  changeMapType(mapTypeObject) {
    if (!mapTypeObject) return;
    const mapType = this.getMapType(mapTypeObject);

    mapType.setRenderingConfig(window.vectorMapConfig);
    mapType.setMaxLevel(18);
    this.map.setCenter(this.map.getCenter(), this.map.getZoom(), mapType);

    this.showGeometryChanges(window.showGeometry);

    this.map.refreshTiles();
  }

  showGeometryChanges(show) {
    if (show) {
      let olrString = window.storage.getOlrString();
      this.mergeGeometryChanges(olrString);
    } else {
      this.mergeGeometryChanges('');
    }
  }

  mergeGeometryChanges(detourProfile) {
    let provider = window.storage.getProvider();
    let aliases;
    if (window.usePostprocessor) {
      aliases = this.map.getOptions().getMapTypeByName('tomtom-latest').getTilesServerConfig().getAliases();
    } else {
      aliases = this.map.getCurrentMapType().getTilesServerConfig().getAliases();
    }

    aliases = aliases.map(it => {
      let alias = this.removeParameter(it, 'SP_USE');
      alias = this.removeParameter(alias, 'MAPPROVIDER');
      return alias + '&SP_USE=' + detourProfile + '&MAPPROVIDER=' + provider;
    });


    if (window.usePostprocessor) {
      this.map.getOptions().getMapTypeByName('tomtom-latest').getTilesServerConfig().setAliases(aliases);
    } else {
      this.map.getCurrentMapType().getTilesServerConfig().setAliases(aliases);
    }
    this.map.refreshTiles();
  }

  removeParameter(url, parameter) {
    let indexStart = url.indexOf('&' + parameter);
    if (indexStart < 0) {
      return url;
    }

    let indexEnd = url.indexOf('&', indexStart + 1);
    if (indexEnd < 0) {
      return url.substr(0, indexStart);
    }

    return url.substr(0, indexStart) + url.substr(indexEnd);
  }


  /**
   * @function renderTrack Redraws all track
   * @memberOf FollowmeMap
   */
  renderTrack(color) {
    this.redrawPartly(Object.keys(this.mapDots.get()), color);
  }

  getMapType(mapTypeObject) {
    let mapType = this.map.getOptions().getMapTypeByName(iwconst.DEFAULT_MAPTYPE);

    if (mapTypeObject && mapTypeObject.name === 'HERE_CHL_2019_09') {
      mapType = this.map.getOptions().getMapTypeByName('vector-here-chl-2019.Q3');
    } else if (mapTypeObject && mapTypeObject.name === 'HERE_CHL_2020_12') {
      mapType = this.map.getOptions().getMapTypeByName('vector-here-chl-2020.Q4');
    } else if (mapTypeObject && mapTypeObject.name === 'TomTom_SAM_2019_03') {
      mapType = this.map.getOptions().getMapTypeByName('vector-tomtom-sam-2019.03');
    } else if (mapTypeObject && mapTypeObject.name === 'TomTom_AUS_2019_03') {
      mapType = this.map.getOptions().getMapTypeByName('vector-tomtom-aus-2019.03');
    } else if (mapTypeObject && 'name' in mapTypeObject) {
      mapType = this.map.getOptions().getMapTypeByName(mapTypeObject.name);
    }

    if (!mapType) {
      let mapString = `infoware, ${mapTypeObject.provider}, Kartendaten ${mapTypeObject.release ? mapTypeObject.release.replace('.', '/') : ''}`;
      mapType = this.map.getOptions().getDynamicMapType(mapTypeObject.name, mapString);

      if (this.map._tileset._vectorTileFactories && this.map._tileset._vectorTileFactories['vectortiles-dynamic']) {
        delete this.map._tileset._vectorTileFactories['vectortiles-dynamic'];
      }
    }

    return mapType;
  }

  /**
   * @function getMapObject Direct access to followme map object
   * @memberOf FollowmeMap
   * @returns {IWMap}
   */
  getMapObject() {
    return this.map;
  }

  /**
   * @memberOf FollowmeMap
   * @returns {Dots}
   */
  getDots() {
    return this.mapDots;
  }

  /**
   * @function toggleTrackDisplay Shows and hides track markers and base lines
   * @memberOf FollowmeMap
   */
  toggleTrackDisplay() {
    this.updateLayoutAndRendererDisplay(this.showTrack, this.MARKER_LAYOUT, this.baseLinesRenderer);

    if (this.staticTrackLines) {
      this.baseLinesRenderer.removeElement(this.staticTrackLines);
      this.staticTrackLines = null;
    }

    if (this.showTrack) {
      this.staticTrackLines = this.redrawBaseLines(this.mapDots, this.baseLinesRenderer, true);
    }
  }

  /**
   * @function toggleDayEventsDisplay Shows and hides day events markers
   * @memberOf FollowmeMap
   */
  toggleDayEventsDisplay() {
    this.updateLayoutAndRendererDisplay(this.showDayEvents, this.DAY_EVENTS_LAYOUT);
  }

  /**
   * @function toggleEventsDisplay Shows and hides track events
   * @memberOf FollowmeMap
   */
  toggleEventsDisplay() {
    this.updateLayoutAndRendererDisplay(this.showEvents, this.EVENT_MARKER_LAYOUT);
  }

  toggleShowAllEventsDisplay() {
    this.redrawPartly(Object.keys(this.mapDots.get()));
  }

  /**
   * @function toggleInstructionsDisplay Shows and hides the instructions
   * @memberOf FollowmeMap
   */
  toggleInstructionsDisplay() {
    this.updateLayoutAndRendererDisplay(this.showRouteInstructions, this.INSTRUCTIONS_LAYOUT);
  }

  /**
   * @function toggleStatusAndRemarksDisplay Shows and hides the instructions
   * @memberOf FollowmeMap
   */
  updateStatusAndRemarksDisplay() {
    if (window.statusBGPolyline && window.statusPolyline
      && window.statusBGPolyline.length > 0 && window.statusPolyline.length > 0) {
      window.statusBGPolyline.forEach(poly => {
        poly.attributes.strokeOpacity = this.showStatusAndRemarks ? 1 : 0;
      });

      window.statusPolyline.forEach(poly => {
        poly.attributes.strokeOpacity = this.showStatusAndRemarks ? 1 : 0;
      });

      this.statusAndRemarksRenderer.render();
    }

    this.updateLayoutAndRendererDisplay(this.showStatusAndRemarks, this.REMARKS_MARKER_LAYOUT, this.statusAndRemarksRenderer);
  }

  /**
   * @function updateLayoutAndRendererDisplay Shows and hides layer and renderer
   * @memberOf FollowmeMap
   */
  updateLayoutAndRendererDisplay(prop, layerId, renderer) {
    let layer = this.map.getOverlayManager().getLayer(layerId);

    layer.setVisible(prop);
    if (prop) layer.redraw();

    if (renderer) {
      renderer._drawingContainer.style.visibility = prop ? 'visible' : 'hidden';
    }
  }

  /**
   * @function clearMap Deletes all overlays
   * @memberOf FollowmeMap
   */
  clearMap() {
    this.setDots(new Dots());
    this.clearTracks();
    this.clearRoute();
    this.clearEvents();
    this.clearInstructions();
    this.clearStatusAndRemarksLayout();
    this.clearSearchMarkers();
  }

  /**
   * @function clearStatusAndRemarksLayout Clears status and remarks info
   * @memberOf FollowmeMap
   */
  clearStatusAndRemarksLayout() {
    this.statusAndRemarksRenderer.clearContainer();
    this.map.getOverlayManager().removeLayer(this.REMARKS_MARKER_LAYOUT);
  }

  /**
   * @function createDefaultMarker Creates default map marker and sets target coordinates
   * @memberOf FollowmeMap
   * @param {Dot} dot
   * @param color
   * @param colorEvent
   * @returns {window.IWMarker}
   */
  createDefaultMarker(dot, color, colorEvent) {
    const marker = new window.IWClassMarker(this.map, dot.getCoordinate().toMercator(), 'track-arrow-svg', null, { registerEvents: false });
    marker.setHotspot(new IWPoint(15, 15));
    const svg = $(window.track_arrow_svg_icon);

    if (typeof color !== 'undefined') {
      svg.find('path').css('fill', color);
    }

    if (dot.hasEvent() && typeof colorEvent !== 'undefined') {
      svg.find('path').css('fill', colorEvent);
    } else if (dot.hasEvent()) {
      svg.find('path').css('fill', '#0a3eaa');
    }

    $(marker._element).html(svg);

    return marker;
  }

  /**
   * @function createCircleMarker Creates circle map marker and sets target coordinates
   * @memberOf FollowmeMap
   * @param {Dot} dot
   * @param {string} color
   * @returns {window.IWClassMarker}
   */
  createCircleMarker(dot, color) {
    const marker = new window.IWClassMarker(this.map, dot.getCoordinate().toMercator());
    marker.setHotspot(new window.IWPoint(9, 9));
    marker.setClassName('dot-marker');

    if (color) {
      marker._element.style.backgroundColor = color;
    }

    return marker;
  }

  /**
   * @function createSmallGreyMarker Creates small grey map marker and sets target coordinates
   * @memberOf FollowmeMap
   * @param {Dot} dot
   * @returns {window.IWSimpleMarker}
   */
  createSmallGreyMarker(dot) {
    let markerClass = 'marker-dot-normal';

    if (dot.hasEvent()) {
      markerClass = 'marker-dot-event';
    }

    return new window.IWSimpleMarker(this.map, dot.getCoordinate().toMercator(), markerClass, {
      registerEvents: false,
      size: { width: 20, height: 20 }
    });
  }

  /**
   * @function createBigMarker Creates big map marker and sets target coordinates
   * @memberOf FollowmeMap
   * @param {Dot} dot
   * @param color
   * @param colorEvent
   * @returns {window.IWMarker}
   */
  createBigMarker(dot, color, colorEvent) {
    const marker = new window.IWClassMarker(this.map, dot.getCoordinate().toMercator(), 'track-arrow-svg-big', null, { registerEvents: false });
    marker.setHotspot(new IWPoint(20, 20));
    const svg = $(window.track_arrow_svg_icon_big);

    if (typeof color !== 'undefined') {
      svg.find('path').css('fill', color);
    }

    if (dot.hasEvent() && typeof colorEvent !== 'undefined') {
      svg.find('path').css('fill', colorEvent);
    } else if (dot.hasEvent()) {
      svg.find('path').css('fill', '#0a3eaa');
    }

    $(marker._element).html(svg);

    return marker;
  }

  /**
   * @function createRouteInstructionMarker
   * @memberOf FollowmeMap
   * @param {window.IWCoordinate} coordinates
   * @param {string} label String to display
   * @returns {window.IWClassMarker}
   */
  createRouteInstructionMarker(coordinates, label) {
    const marker = new window.IWClassMarker(this.map, coordinates.toMercator(), 'selectedRouteInstructionClass');
    marker.setHotspot(new window.IWPoint(9, 9));
    marker.setContainerClassname('selectedRouteInstructionClass');
    marker.setClassName('dot-route-marker');
    marker.setLabel(label);
    return marker;
  }

  /**
   * @function createRouteInstructionMarker
   * @memberOf FollowmeMap
   * @param {window.IWCoordinate} coordinates
   * @param {string} iconName Icon to display
   * @returns {window.IWClassMarker}
   */
  createRouteIconMarker(coordinates, iconName) {
    const marker = new window.IWMarker(this.map, coordinates.toMercator());
    let center = new IWPoint(19, 47);
    let size = new IWSize(39, 57);
    let scalableSize = new IWSize(19, 28);
    let scalableSizeCenter = new IWPoint(9, 28);

    if (iconName.indexOf('gps_') !== -1) {
      size = new IWSize(24, 32);
      center = new IWPoint(12, 16);
      scalableSize = new IWSize(12, 16);
      scalableSizeCenter = new IWPoint(6, 8);
    }

    marker.setDefaultIcon(new IWIcon('./img/route-icons/' + iconName, center, size));
    marker.addScaleDependentIcon(new IWScaleDependentIcon('./img/route-icons/' + iconName, scalableSizeCenter, scalableSize, new IWRange(1, 15)));

    return marker;
  }

  /**
   * @function createEventMarker Creates label with selected Event and sets target coordinates
   * @memberOf FollowmeMap
   * @param {window.IWCoordinate} coordinates
   * @param {Event|EventCustom} dotEvent Event info
   * @param {string} markerType Is marker selected or in caterpillar
   * @param {int} dotIndex Index of dot of this event marker
   * @returns {IWClassMarker}
   */
  createEventMarker(coordinates, dotEvent, markerType, dotIndex) {
    const createMarker = () => {
      // This is a toggle event (Backwards/Forwards) and the event needs to be names accordingly
      // We'll count if this dot is Backwards or Forwards
      let isForwards;

      if (dotEvent.getId() === 65552) {
        for (let i = 0; i < dotIndex; i++) {
          const dot = this.mapDots.getByIndex(i);

          if (dot.hasEvent() && dot.getEvent().getId() === 65552) {
            isForwards = !isForwards;
          }
        }
      }

      let eventName;

      if(dotEvent.getId() === 65538) {
        dotEvent._id = 65543;
      }

      if(window.CONSTANTS.DYNAMIC_DEFAULT_EVENTS.includes(dotEvent.getId().toString()) && Object.keys(window.CONSTANTS.DEFAULT_EVENT_KEYS_MOD).includes(dotEvent.getName())) {
        let translationKey = window.CONSTANTS.DEFAULT_EVENT_KEYS_MOD[dotEvent.getName()][dotEvent.getId()];

        if(dotEvent.getId() === 65539) {
          translationKey = 'events.transfer';
        }

        eventName = i18next.t(translationKey);
      }

      if(!eventName && dotEvent.getName().includes("customaction_")) {
        let customAction = dotEvent.getName().split('_')[1];
        if(dotEvent.getId() === 65541) {
          eventName = i18next.t('events.custom-left-side', {custom: customAction})
        } else if (dotEvent.getId() === 65540) {
          eventName = i18next.t('events.custom-right-side', {custom: customAction})
        } else if(dotEvent.getId() === 65542) {
          eventName = i18next.t('events.custom-both-sides',{custom: customAction})
        } else if(dotEvent.getId() === 65543 || id === 65538) {
          eventName = i18next.t('events.custom-no-sides', {custom: customAction})
        }
      }

      if(!eventName && window.CONSTANTS.LEGACY_DEFAULT_EVENT_TRANSLATIONS.includes(dotEvent.getName())) {
        eventName = window.getEventNameByID(dotEvent.getId());
      }

      if (isForwards) {
        eventName = window.getEventNameByID('065552');
      }

      if (!eventName) {
        eventName = dotEvent.getName();
      }

      if (dotEvent.getName().length >= 35) {
        eventName = dotEvent.getName().substring(0, 35) + '...';
      }

      if (dotEvent.getIsEditable() || dotEvent.getId() === 65555) {
        if (dotEvent.getDescription().length >= 40) {
          eventName += '<small>' + (dotEvent.getDescription().substring(0, 37) + '...') + '</small>';
        } else {
          eventName += '<small>' + dotEvent.getDescription() + '</small>';
        }
      }

      let eventColor = window.getColorCodeFromEventID(dotEvent);

      if (!eventName) {
        eventName = i18next.t('events.' + dotEvent.getId());
        if (eventName === '') {
          eventName = dotEvent.getId();
        }
      }

      const marker = new window.IWClassMarker(this.map, coordinates.toMercator(), 'dot-event', eventName, eventColor);
      const markerJQ = $(marker)[0];

      this.enableMarkerZoomActions(marker);
      marker.setContainerClassname('dot-event');

      window.enableContextMenu(window.createEventOnDotContextMenu.bind(null, dotIndex, dotEvent), $(marker.getContainer()));

      markerJQ._label.style.borderLeft = '4px solid ' + eventColor;
      markerJQ._label.style.top = 'auto';

      if (markerType === 'small') {
        markerJQ._label.style.bottom = '10px';
      } else if (markerType === 'big') {
        markerJQ._label.style.bottom = '15px';
      } else {
        markerJQ._label.style.bottom = '12px';
      }

      return marker;
    };

    const createCustomMarker = () => {
      const eventLabel = this.getEventCustomLabel(dotEvent);

      const eventColor = dotEvent.getColor() ? dotEvent.getColor() : 'white';
      const marker = new window.IWClassMarker(this.map, coordinates.toMercator(), 'dot-event', eventLabel, eventColor);
      let markerJQ = $(marker)[0];

      this.enableMarkerZoomActions(marker);
      marker.setContainerClassname('dot-event');

      window.enableContextMenu(window.createEventOnDotContextMenu.bind(null, dotIndex, dotEvent), $(marker.getContainer()));

      markerJQ._label.style.borderLeft = '4px solid ' + eventColor;
      markerJQ._label.style.top = 'auto';

      if (markerType === 'small') {
        markerJQ._label.style.bottom = '11px';
      } else if (markerType === 'big') {
        markerJQ._label.style.bottom = '17px';
      } else {
        markerJQ._label.style.bottom = '14px';
      }

      return marker;
    };

    switch (dotEvent.constructor.name) {
      case 'Event':
        return createMarker();
      case 'EventCustom':
        return createCustomMarker();
      default:
        throw new Error('Event type is not supported');
    }
  }

  /**
   * @function getRawTrackDots Converts map dots to array with Dot
   * @memberOf FollowmeMap
   * @returns {Dot[]}
   */
  getRawTrackDots(dots) {
    if (!dots) dots = this.mapDots.get();
    return dots.map(this.convertDotToRawDot);
  }

  getRawTrackDotsByTrackName(trackName) {
    if(!this.editingTracks[trackName]) return [];
    return this.getRawTrackDots(this.editingTracks[trackName].dots.get())
  }

  /**
   * @function convertDotToRawDot Converts dot to raw Dot
   * @memberOf FollowmeMap
   * @returns {Dot}
   */
  convertDotToRawDot(d) {
    return {
      hash: d.getHash(),
      lat: d.getLatitude(),
      lon: d.getLongitude(),
      event: d.getEvent(),
      eventType: d.hasEvent() ? d.getEvent().constructor.name : null
    };
  }

  /**
   * @function saveTrackDots Saves track dots to local storage
   * @memberOf FollowmeMap
   * @param {Boolean} [notChanged] Shows is track was not changed. Default to false.
   */
  saveTrackDots(notChanged) {
    const dots = this.getRawTrackDots();
    if (!notChanged) {
      window.storage.trackChanged();
      window.trackManager.saveTrackDots(dots);
    }
  }

  /**
   * @function setTrackStatusAndRemarks Saves track dots to local storage
   * @memberOf FollowmeMap
   * @param {Object} statusAndRemarks
   */
  setTrackStatusAndRemarks(statusAndRemarks) {
    this.statusAndRemarks = statusAndRemarks;
  }

  /**
   * @function assignEventToDots Assigns event to dot
   * @memberOf FollowmeMap
   * @param {string} eventId
   * @param {int} [dotIndex]
   */
  assignEventToDots(eventId, dotIndex) {
    let i;
    const toAssign = dotIndex !== undefined ? [dotIndex] : this.selectedDots;
    this.saveMapState();
    this.redoStates = [];
    let event;

    for (i = 0; i < toAssign.length; i += 1) {
      if (!this.mapDots.getByIndex(toAssign[i])) continue;

      let eventIsDefault = 'defaultEvent' in this.events[eventId] ? this.events[eventId].defaultEvent : false;
      let name = this.events[eventId].name;

      if(window.CONSTANTS.DYNAMIC_DEFAULT_EVENTS.includes(eventId.toString())) {
        name = window.storage.getFollowMeMod();
      }

      if(eventId === 65539 || eventId === "65539") {
        name = "TRANSFER";
      }

      event = new Event(
        parseInt(eventIsDefault === true ? this.events[eventId].id : 1, 10),
        name,
        this.events[eventId].desc,
        this.events[eventId].color,
        eventIsDefault,
        true
      );

      this.mapDots.getByIndex(toAssign[i]).setEvent(event);
    }

    this.saveTrackDots();
    this.redrawPartly(toAssign);
    if (eventId === '65555' || eventId === '65553') showModifyInlineEventPopup(toAssign, event);
  }

  /**
   * Looks for the closest dot that has the same event attached to it and it retrieves its values
   *
   * @param dotId
   * @param eventCode
   */
  getCustomEventPredefinedValue(dotId, eventCode) {
    dotId = dotId || this.selectedDots[0];

    let getEventFromDot = (index) => {
      let dot = this.mapDots.getByIndex(index);
      if (typeof dot === 'undefined') return false;

      if (!dot.hasEvent()) return false;

      const event = dot.getEvent();

      if (event.constructor.name !== 'EventCustom' || event.getId() !== eventCode) return false;

      return event;
    };

    let event;
    let leftResult = null;
    let rightResult = null;

    // check the left
    for (let i = dotId; i >= 0; i--) {
      event = getEventFromDot(i);

      if (!event) continue;

      leftResult = {
        distance: dotId - i,
        event: event
      };

      break;
    }

    // check the right
    for (let j = dotId; j <= this.mapDots.getTotal(); j++) {
      event = getEventFromDot(j);

      if (!event) continue;

      rightResult = {
        distance: j - dotId,
        event: event
      };

      break;
    }

    if (leftResult === null && rightResult === null) return null;
    if (leftResult !== null && rightResult === null) return leftResult.event;
    if (leftResult === null && rightResult !== null) return rightResult.event;

    if (leftResult.distance <= rightResult.distance) return leftResult.event;
    if (leftResult.distance > rightResult.distance) return rightResult.event;

    return null;
  }

  /**
   * @function assignEventToDots Assigns event to dot
   * @memberOf FollowmeMap
   * @param code
   * @param name
   * @param color
   * @param content
   * @param dotId
   */
  assignCustomEventToDots(code, name, color, content, dotId) {
    const toAssign = dotId ? [dotId] : this.selectedDots;
    this.saveMapState();
    this.redoStates = [];

    for (let i = 0; i < toAssign.length; i += 1) {
      let dot = this.mapDots.getByIndex(toAssign[i]);
      if (!dot) continue;
      dot.setEvent(new EventCustom(
        parseInt(code, 10),
        name,
        content,
        color,
        true
      ));
    }

    this.saveTrackDots();
    this.redrawPartly(toAssign);
  }

  /**
   * @function removeEventFromDot Deletes event assigned to dot
   * @memberOf FollowmeMap
   * @param {int} dotIndex
   */
  removeEventFromDot(dotIndex) {
    this.saveMapState();
    this.mapDots.getByIndex(dotIndex).clearEvent();

    this.saveTrackDots();
    this.redoStates = [];

    this.redrawPartly([dotIndex]);
  }

  /**
   * @function zoomToBounds Zooms map to see all dots
   * @memberOf FollowmeMap
   */
  zoomToBounds(coordinates) {
    let bounds;
    let cords = coordinates;

    if (!coordinates) cords = this.getDotsCoordinates(this.mapDots);

    if (cords.length > 0) {
      bounds = new window.IWBounds(cords);
      this.map.setCenter(bounds.getCenter(), this.map.getBoundsZoomlevel(bounds));
    }
  }

  /**
   * @function zoomToBounds Zooms map to the latest chosen Track (with decreased zoom level)
   * @memberOf FollowmeMap
   */
  zoomToBoundsLiveView(coordinates) {
    let bounds;
    let cords = coordinates;

    if (!coordinates) cords = this.getDotsCoordinates(this.mapDots);

    if (cords.length > 0) {
      bounds = new window.IWBounds(cords);
      this.map.setCenter(bounds.getCenter(), this.map.getBoundsZoomlevel(bounds));
    }
  }

  /**
   * @function enableContextMenuForMarker Attaches context menu to marker
   * @memberOf FollowmeMap
   * @param {window.IWClassMarker|window.IWMarker} marker
   * @param {Function} contextMenuFn Function to call on right click
   * @returns {window.IWClassMarker|window.IWMarker}
   */
  enableContextMenuForMarker(marker, contextMenuFn) {
    this.enableMarkerZoomActions(marker);
    if (contextMenuFn) {
      window.enableContextMenu(contextMenuFn, $(marker.getContainer()));
    }
    return marker;
  }

  /**
   * @function getDotsCoordinates Returns dots coordinates objects from dots
   * @memberOf FollowmeMap
   * @param {Dots} dots
   * @returns {Dot[]}
   */
  getDotsCoordinates(dots) {
    return dots.get().filter((dot) => {
      return dot.isDrawable();
    }).map((dot) => {
      return dot.getCoordinate();
    });
  }

  /**
   * @function redrawBaseLines Redraws base gray lines between dots
   * @memberOf FollowmeMap
   */
  redrawBaseLines(dots, renderer, clearContainer) {
    const lineAttributes = { stroke: '#6b6b6b', strokeWidth: 2, strokeOpacity: 1 };
    if (clearContainer) {
      renderer.clearContainer();
    }

    if (dots.getTotalVisible() < 2) return;

    let staticBaseLines = renderer.drawPolyline(this.getDotsCoordinates(dots), lineAttributes);
    renderer.render();
    return staticBaseLines;
  }

  /**
   * @function updateDotIndexes Updates all the dots indexes
   * @param {Dots} dots
   * @memberOf FollowmeMap
   */
  updateDotIndexes(dots) {
    dots.get().forEach((dot, index) => {
      $(dot.getMarker().getContainer()).data('index', index);
    });
  }

  /**
   * Updates dot marker and dot event marker coordinate and rotation
   * @param {number} index
   * @param {number} angle
   * @param {IWCoordinate} coordinate
   */
  updateDotMarkers(index, angle, coordinate) {
    const dot = this.mapDots.getByIndex(index);
    if (!dot.isDrawable()) return;

    let marker = dot.getMarker();

    marker.setCoordinate(coordinate);
    marker.setRotation(angle);
    marker.redraw();

    if (dot.hasMarkerEvent()) {
      if (dot.getEvent().constructor.name === 'EventCustom') {
        // UPDATE LATITUDE AND LONGITUDE AUTOMATICALLY - CONFLICTS with the the point number on the event
        // dot.getMarkerEvent().setLabel(this.getEventCustomLabel(dot.getEvent()));
      }
      dot.getMarkerEvent().setCoordinate(coordinate);
      dot.getMarkerEvent().redraw();
    }
  }

  /**
   * @function updateAllDotsMarkers Rotates and places markers to new coordinates
   * @memberOf FollowmeMap
   * @param {int[]} changedDots Indexes of changed dots
   */
  updateAllDotsMarkers(changedDots) {
    let i;
    let index;
    let angle;
    let dotCoordinate;
    let prevDotCoordinate;
    const affectedDots = this.getAffectedDots(changedDots);

    for (index = 1; index < affectedDots.length; index += 1) {
      i = affectedDots[index];
      if (!this.mapDots.getByIndex(i)) return;
      dotCoordinate = this.mapDots.getByIndex(i).getCoordinate();
      prevDotCoordinate = this.mapDots.getByIndex(i - 1).getCoordinate();

      angle = FollowmeMap.getAngle(prevDotCoordinate, dotCoordinate);

      this.updateDotMarkers(i - 1, angle, prevDotCoordinate);

      if (i === this.mapDots.getTotalVisible() - 1) {
        this.updateDotMarkers(i, angle, dotCoordinate);
      }
    }
  }

  /**
   * @function toggleMarkerSelection Add or disables selection for dot
   * @memberOf FollowmeMap
   * @param dotIndex
   */
  toggleMarkerSelection(dotIndex, mouseUpEvent) {
    let indexInSelected;
    let selectedDots = this.selectedDots;
    let changedDots = [dotIndex];

    if (mouseUpEvent.altKey === true) {

      const dot = this.mapDots.getByIndex(dotIndex);
      if (!dot.hasEvent()) return;

      dot.getEvent().setIsDrawable(!dot.getEvent().getIsDrawable());
      this.saveTrackDots();
    }

    // Toggle selection
    if (mouseUpEvent.shiftKey === true) {

      if(selectedDots.length === 0) return;

      const previousSelectedDots = this.selectedDots;
      let startIndex = selectedDots[0];

      const lower = this.selectedDots.some(i => i > dotIndex) && !this.selectedDots.includes(dotIndex);

      if(lower) {
        startIndex = selectedDots[selectedDots.length -1];
      }

      selectedDots = [];
      if(dotIndex > startIndex) {

        for(let i = startIndex; i <= dotIndex; i++) {
          selectedDots.push(i)
        }
      } else {
        for(let i = startIndex; i >= dotIndex; i--) {
          selectedDots.push(i)
        }
        selectedDots.sort();
      }

      this.selectedDots = selectedDots;
      this.highlightTableRows(this.selectedDots);
      this.redrawPartly(previousSelectedDots.concat(this.selectedDots));
      return;


      /*
      indexInSelected = selectedDots.indexOf(parseInt(dotIndex, 10));

      if (indexInSelected !== -1) selectedDots.splice(indexInSelected, 1);
      else selectedDots.push(parseInt(dotIndex, 10));

      selectedDots = selectedDots.sort((a, b) => {
        return a - b;
      });*/
    } else {
      changedDots = changedDots.concat(selectedDots);
      selectedDots = [parseInt(dotIndex, 10)];
    }

    this.selectedDots = selectedDots;
    this.highlightTableRows(this.selectedDots);
    this.redrawPartly(changedDots);
  }

  /**
   * Removes listeners from dots and adds context menu to select track
   * @param {Dots} dots
   * @param trackName
   */
  makeTrackDotsStatic(dots, trackName) {
    dots.get().forEach((dot, index) => {
      if (!dot.isDrawable()) return;

      let marker = dot.getMarker();
      if (!marker) return;
      let markerContainer = marker.getContainer();

      markerContainer.ondragstart = null;
      markerContainer.onmousedown = null;
      markerContainer.onmouseup = window.trackManager.selectTrack.bind(window.trackManager, trackName);
      markerContainer.onmouseover = null;
      markerContainer.onmouseout = null;

      this.enableContextMenuForMarker(marker, window.createSelectTrackContextMenu.bind(null, trackName));
    });
  }

  /**
   * Attaches mouse listeners for dot marker
   * @param {Dot} dot
   * @param {int} index
   * @param {int} dotCountIndex
   * @param {int} totalVisibleDots
   */
  makeTrackDotActive(dot, index, dotCountIndex, totalVisibleDots) {
    if (!dot.isDrawable()) return;
    let showEvent = !window.followmeMap.showAllEvents ? this.selectedDots.includes(index) : true;

    $(dot.getMarker().getContainer())
      .data('index', index);

    if (dot.hasEvent() && dot.getEvent().getIsDrawable() && showEvent) {
      const label = $(dot.getMarkerEvent().getContainer()).find('.label');
      const countBox = label.find('.event-bubble-count');
      const text = i18next.t('general.dot-index-count', { index: dotCountIndex, total: totalVisibleDots });

      if (!countBox.length > 0) {
        label.append($('<span>', { class: 'event-bubble-count', text: text }));
      } else {
        countBox.text(text);
      }
    }
  }

  markerOnMouseDown(index, isSelected, mouseDownEvent) {
    // if not left mouse click exit
    if (mouseDownEvent.which !== 1) return;

    this.saveMapState();

    this.clicked = true;

    const moveDots = (dotsIndexes, mapStartPosition, mouseMoveEvent) => {
      let j;
      let box;
      let shiftY;
      let shiftX;
      let dotIndex;
      let yTranslate;
      let xTranslate;
      let lonTranslate;
      let latTranslate;
      let movingContainer;
      const x = this.dragEnd.pageX - mapStartPosition.left;
      const y = this.dragEnd.pageY - mapStartPosition.top;
      const newCoordinate = this.map.getCurrentMapType()
        .getProjection()
        .pixelToMeter(new window.IWPoint(x, y)).toWGS84();

      // Calculating real world translation
      lonTranslate = newCoordinate.getX() - this.mapDots.getByIndex(index).getLongitude();
      latTranslate = newCoordinate.getY() - this.mapDots.getByIndex(index).getLatitude();

      for (j = 0; j < dotsIndexes.length; j += 1) {
        dotIndex = dotsIndexes[j];
        const dot = this.mapDots.getByIndex(dotIndex);
        if (!dot.isDrawable()) continue;
        movingContainer = dot.getMarker().getContainer();
        box = movingContainer.getBoundingClientRect();

        // Calculating length to marker center
        shiftY = (mouseDownEvent.pageY - box.top) + window.pageYOffset;
        shiftX = (mouseDownEvent.pageX - box.left) + window.pageXOffset;

        // Calculating FE translation
        yTranslate = mouseMoveEvent.pageY - this.map._divWindowOverlayY -
          mapStartPosition.top - shiftY;
        xTranslate = mouseMoveEvent.pageX - this.map._divWindowOverlayX -
          mapStartPosition.left - shiftX;

        movingContainer.style.transform = 'translate(' + (xTranslate) + 'px,' + (yTranslate) + 'px)';

        // Save new dot position
        const dotToUpdate = this.mapDots.getByIndex(dotIndex);
        dotToUpdate.setLongitude(dotToUpdate.getLongitude() + lonTranslate);
        dotToUpdate.setLatitude(dotToUpdate.getLatitude() + latTranslate);
      }
    };

    // eslint-disable-next-line consistent-return
    document.onmousemove = (mouseMoveEvent) => {
      const mapPosition = this.map.getContainer().getBoundingClientRect();

      if (!this.clicked) return this.mapDots.getByIndex(index).getMarker().getContainer().onmouseup(this.dragEnd);

      this.moving = true;
      this.dragEnd = mouseMoveEvent;

      if (isSelected) {
        moveDots(this.selectedDots, mapPosition, mouseMoveEvent);
      } else {
        moveDots([index], mapPosition, mouseMoveEvent);
      }

      this.updateAllDotsMarkers(this.getAffectedDots(this.selectedDots.concat(index)));
      this.staticTrackLines = this.redrawBaseLines(this.mapDots, this.baseLinesRenderer, true);

      mouseMoveEvent.stopPropagation();
    };

    document.onmouseup = (mouseUpEvent) => {
      if (!this.clicked) return;
      this.clicked = false;
      this.moving = false;
      // Delete all listeners on move end
      document.onmousemove = null;
      document.onmouseup = null;

      // If not drag and left mouse click - just toggle selection
      if (!this.dragEnd && mouseUpEvent.which === 1 && !this.editingMode) {
        this.dragEnd = null;
        return this.toggleMarkerSelection(index, mouseUpEvent);
      }

      this.dragEnd = null;

      // Save new dots positions
      this.saveTrackDots();
      this.redoStates = [];
    };
  }

  /**
   * @function makeTrackDotsActive Allows to move dot or dots within the map
   * @memberOf FollowmeMap
   */
  makeTrackDotsActive(targetDots) {
    let dotCountIndex = 1;
    const totalVisibleDots = this.mapDots.getTotalVisible();

    this.mapDots.get().forEach((dot, index) => {
      if (!dot.isDrawable()) return;
      if (!targetDots || targetDots.indexOf(index) !== -1) {
        this.makeTrackDotActive(dot, index, dotCountIndex, totalVisibleDots);
      }
      dotCountIndex++;
    });
  }

  /**
   * @function enableMarkerZoomActions zooming map when hover marker
   * @memberOf FollowmeMap
   * @param marker
   */
  enableMarkerZoomActions(marker) {
    // var self = this;
    // var point;

    /* marker.getContainer().addEventListener('mousewheel', function (event) {
      point = new window.IWPoint(event.layerX, event.layerY);
      if (event.deltaY === 100) self.map.zoom(self.map._zoomLevel - 1, point, false, true);
      if (event.deltaY === -100) self.map.zoom(self.map._zoomLevel + 1, point, false, true);
    }); */
  }

  /**
   * @function setDots Sets track dots
   * @memberOf FollowmeMap
   * @param {Dot[]} dots
   */
  setDots(dots) {
    this.mapDots = dots;
    this.selectedDots = [this.mapDots.getTotalVisible() - 1];
    this.saveTrackDots(true);
  }

  /**
   * @function Sets the current version of the loaded track
   * @memberOf FollowmeMap
   * @param {number} version
   */
  setCurrentTrackVersion(version) {
    this.currentTrackVersion = version;
  }

  /**
   * @function addDot Adds dot to inner dots array
   * @memberOf FollowmeMap
   * @param {Dot} dot
   * @param {Number} [index] Where to insert dot
   */
  addDot(dot, index) {
    let indexToInsert = 0;

    if (index) {
      indexToInsert = index;
    } else if (this.selectedDots[this.selectedDots.length - 1] !== -1) {
      indexToInsert = this.selectedDots[this.selectedDots.length - 1] + 1;
    } else if (this.mapDots.getTotal() > 0) {
      indexToInsert = this.mapDots.getTotal();
    }

    const changedDots = this.selectedDots.concat(indexToInsert);
    if (this.selectedDots.length > 1) return;

    this.saveMapState();
    this.redoStates = [];

    this.selectedDots = [indexToInsert];
    this.mapDots.addAtIndex(indexToInsert, new Dot(parseFloat(dot.lat), parseFloat(dot.lon)));

    this.saveTrackDots();

    this.redrawPartly(changedDots);
  }

  /**
   * @function addDot Adds many to inner dots array
   * @memberOf FollowmeMap
   * @param {Dot[]} dots
   * @param {Number} [index] Where to insert dots
   */
  addManyDots(dots, index) {
    let indexToInsert = 0;

    if (index) {
      indexToInsert = index;
    } else if (this.selectedDots[this.selectedDots.length - 1] !== -1) {
      indexToInsert = this.selectedDots[this.selectedDots.length - 1] + 1;
    } else if (this.mapDots.getTotal() > 0) {
      indexToInsert = this.mapDots.getTotal();
    }

    let changedDots = this.selectedDots.concat(indexToInsert);
    if (this.selectedDots.length > 1) return;

    this.saveMapState();
    this.redoStates = [];

    this.selectedDots = [];
    for (let i = 0; i < dots.length; i++) {
      const dot = dots[i];
      changedDots.push(indexToInsert + i);
      this.selectedDots.push(indexToInsert + i);
      this.mapDots.addAtIndex(indexToInsert + i, new Dot(parseFloat(dot.lat), parseFloat(dot.lon), dot.event));
    }

    this.saveTrackDots();

    this.redrawPartly(changedDots);
  }

  selectAllDots() {
    this.selectedDots = [];
    for(let i = 0; i < this.mapDots.getTotal(); i++) {
      this.selectedDots.push(i);
    }
    this.redrawPartly(this.selectedDots);
  }

  selectFromHere(dot) {
    this.selectFromHereIndex = dot;
    const previousSelectedDots = this.selectedDots;
    this.selectedDots = [dot];
    this.redrawPartly(previousSelectedDots.concat(this.selectedDots));
  }

  selectToHere(dotIndex) {
    const previousSelectedDots = this.selectedDots;
    let startIndex = this.selectFromHereIndex;

    const selectedDots = [];
    if(dotIndex > startIndex) {

      for(let i = startIndex; i <= dotIndex; i++) {
        selectedDots.push(i)
      }
    } else {
      for(let i = startIndex; i >= dotIndex; i--) {
        selectedDots.push(i)
      }
      selectedDots.sort();
    }

    this.selectedDots = selectedDots;
    this.highlightTableRows(this.selectedDots);
    this.redrawPartly(previousSelectedDots.concat(this.selectedDots));
    return;
  }

  /**
   * @function getSelectedDots Returns selected dots in raw format
   * @memberOf FollowmeMap
   * @returns {Dot[]}
   */
  getSelectedDots() {
    return this.selectedDots.map((dotIndex) => {
      return this.convertDotToRawDot(this.mapDots.getByIndex(dotIndex));
    });
  }

  /**
   * @function deleteSelectedDots Deletes dot from array trackDots and from map
   * @memberOf FollowmeMap
   * @param {number} dotIndex Indexes to delete
   */
  deleteSelectedDots(dotIndex) {
    let i;
    let dotsIndexesToDelete = this.selectedDots;
    const indexInSelected = dotIndex ? this.selectedDots.indexOf(dotIndex) : 0;

    if (indexInSelected === -1) {
      dotsIndexesToDelete = [dotIndex];
    }

    this.saveMapState();
    this.redoStates = [];

    this.clearTargetDots(this.getAffectedDots(dotsIndexesToDelete));

    this.mapDots.deleteDots(dotsIndexesToDelete);

    if (indexInSelected === -1) {
      for (i = 0; i < this.selectedDots.length; i += 1) {
        if (this.selectedDots[i] > dotIndex) this.selectedDots[i] -= 1;
      }
    } else if (this.selectedDots.length > 1) {
      this.selectedDots = [this.mapDots.getTotal() - 1];
    }

    this.selectedDots = this.selectedDots.filter((dot) => {
      return this.mapDots.getByIndex(dot);
    });

    if (this.selectedDots.length < 1) {
      this.selectedDots = [this.mapDots.getTotal() - 1];
    }

    this.saveTrackDots();

    this.redrawPartly(dotsIndexesToDelete.concat(this.selectedDots));

    this.buildDotTable();
  }

  /**
   * @function getMapState Returns current map state (dots and selections)
   * @memberOf FollowmeMap
   * @returns {object} mapState
   */
  getMapState() {
    return JSON.parse(JSON.stringify({ trackDots: this.getRawTrackDots(), selectedDots: this.selectedDots }));
  }

  /**
   * @function Saves current map state and adds it to undo states
   * @memberOf FollowmeMap
   */
  saveMapState() {
    const mapState = this.getMapState();
    window.trackManager.saveMapState(mapState);
    this.undoStates.push(mapState);
    this.saveTrackDots(true);
  }

  /**
   * @function restoreMapState Restores map state
   * @memberOf FollowmeMap
   * @param {Object} state
   * @param {Dot[]} state.trackDots
   * @param {int[]} state.selectedDots
   * @param {String} color Color for markers
   */
  restoreMapState(state, color) {
    let i;
    const trackDots = state.trackDots;
    const maxLength = trackDots.length > this.mapDots.getTotal() ? trackDots.length : this.mapDots.getTotal();
    let changedDots = state.selectedDots.concat(this.selectedDots);
    const newMapDots = [];

    let newDots = {};
    let oldMapDots = {};
    let k;

    for (i = 0; i < maxLength; i += 1) {
      if (trackDots[i]) {
        k = trackDots[i].lat.toString() + trackDots[i].lon.toString();

        if (oldMapDots[k] && trackDots[i].hash === this.mapDots.getByIndex(oldMapDots[k]).getHash()) {
          newMapDots.push(this.mapDots.getByIndex(oldMapDots[k]));
          delete oldMapDots[k];
        } else {
          const dotNew = FollowMeMapUtils.restoreDot(trackDots[i]);
          newMapDots.push(dotNew);
          newDots[k] = i;
        }
      }

      const dot = this.mapDots.getByIndex(i);

      if (dot) {
        k = dot.getLatitude().toString() + dot.getLongitude().toString();

        if (newDots[k] && newMapDots[newDots[k]].getHash() === dot.getHash()) {
          newMapDots[newDots[k]] = dot;
          delete newDots[k];
        } else {
          oldMapDots[k] = i;
        }
      }
    }

    changedDots = changedDots.concat(Object.values(oldMapDots)).concat(Object.values(newDots));

    this.clearTargetDots(this.getAffectedDots(changedDots));

    this.selectedDots = state.selectedDots;
    this.mapDots.replaceWith(newMapDots);

    this.redrawPartly(changedDots, color);
  }

  /**
   * @function undoAction Undo last action
   * @memberOf FollowmeMap
   */
  undoAction() {
    const state = this.undoStates.pop();
    if (!state) return;

    this.redoStates.push(this.getMapState());

    this.restoreMapState(state);

    this.saveTrackDots(true);
  }

  /**
   * @function redoAction Redo last action
   * @memberOf FollowmeMap
   */
  redoAction() {
    const state = this.redoStates.pop();
    if (!state) return;

    this.undoStates.push(this.getMapState());

    this.restoreMapState(state);

    this.saveTrackDots(true);
  }

  /**
   * @function drawLineToCursor Draws gray line from last dot to cursor position
   * @memberOf FollowmeMap
   * @param x
   * @param y
   */
  drawLineToCursor(x, y) {
    const selectedDot = this.mapDots.getByIndex(this.selectedDots[this.selectedDots.length - 1]);
    const nextDot = this.mapDots.getByIndex(this.selectedDots[this.selectedDots.length - 1] + 1);
    let cursorCoordinate;
    const attributes = {
      stroke: '#818181',
      strokeWidth: 1.5,
      fillOpacity: 1
    };

    if (!selectedDot || !this.showTrack) return;
    cursorCoordinate = this.map.getCurrentMapType()
      .getProjection()
      .pixelToMeter(new window.IWPoint(x, y));

    this.lineToMouseRenderer.clearContainer();
    this.lineToMouseRenderer.drawLine(selectedDot.getCoordinate(), cursorCoordinate, attributes);

    if (nextDot && nextDot.isDrawable()) {
      this.lineToMouseRenderer.drawLine(nextDot.getCoordinate(), cursorCoordinate, attributes);
    }

    this.lineToMouseRenderer.render();
  }

  drawSelectPolygon(x, y, coordinates) {

    this.clickedCoordinates = coordinates;

    let cursorCoordinate;
    const attributes = {
      fill: '#7a7a7a',
      stroke: '#000',
      strokeOpacity: 0.6,
      strokeWidth: 2,
      fillOpacity: 0.2
    };

    if(!this.showTrack) return;

    cursorCoordinate = this.map.getCurrentMapType()
      .getProjection()
      .pixelToMeter(new window.IWPoint(x, y));

    this.selectPolygonRenderer.clearContainer();
    this.selectPolygonRenderer.drawPolygon(coordinates, attributes);

    this.selectPolygonRenderer.render();
  }

  drawPolygonLineToCursor(x, y) {
    let cursorCoordinate;
    const attributes = {
      fill: '#7a7a7a',
      stroke: '#000',
      strokeOpacity: 0.6,
      strokeWidth: 2,
      fillOpacity: 0.2
    };

    if(!this.showTrack) return;

    cursorCoordinate = this.map.getCurrentMapType()
      .getProjection()
      .pixelToMeter(new window.IWPoint(x, y));

    this.lineToMouseRenderer.clearContainer();

    if(this.clickedCoordinates[0]) this.lineToMouseRenderer.drawLine(this.clickedCoordinates[0], cursorCoordinate, attributes);
    if(this.clickedCoordinates[this.clickedCoordinates.length - 1]) this.lineToMouseRenderer.drawLine(this.clickedCoordinates[this.clickedCoordinates.length - 1], cursorCoordinate, attributes);

    this.selectPolygonRenderer.render();
  }

  drawLassoLines(x, y) {
    let cursorCoordinate;
    cursorCoordinate = this.map.getCurrentMapType()
      .getProjection()
      .pixelToMeter(new window.IWPoint(x, y));

    this.clickedCoordinates.push(cursorCoordinate);

    const attributes = {
      fill: '#7a7a7a',
      stroke: '#000',
      strokeOpacity: 0.6,
      strokeWidth: 2,
      fillOpacity: 0.2
    };

    this.lineToMouseRenderer.clearContainer();
    this.lineToMouseRenderer.drawPolygon(this.clickedCoordinates, attributes);
    this.lineToMouseRenderer.drawLine(this.clickedCoordinates[0], cursorCoordinate, attributes);
    this.lineToMouseRenderer.render();
  }

  getDotsInPolygon() {
    const bounds = new IWBounds(this.clickedCoordinates);
    const dotsToSearch = [];
    this.mapDots.get().forEach((dot, index) => {
      if(bounds.containsCoordinate(dot.getCoordinate().toMercator())) {
        dotsToSearch.push({position: index, point: [dot.getLongitude(), dot.getLatitude()]});
      }
    });

    const polygonPoints = this.clickedCoordinates.map(point => [point.toWGS84().getX(), point.toWGS84().getY()]);

    let foundDots = [];
    dotsToSearch.forEach(dot => {
      const result = classifyPoint(polygonPoints, dot.point);
      if(result <= 0) foundDots.push(dot.position);
    });

    if(foundDots.length === 0) return;
    const previousSelectedDots = this.selectedDots;
    this.selectedDots = foundDots;
    this.redrawPartly(previousSelectedDots.concat(this.selectedDots));
  }

  /**
   * @function dotToCoordinate Convert dot to IWCoordinate
   * @memberOf FollowmeMap
   * @param {Dot} dot
   * @returns {IWCoordinate}
   */
  dotToCoordinate(dot) {
    return new window.IWCoordinate(
      dot.lon,
      dot.lat,
      window.IWCoordinate.WGS84
    );
  }

  /**
   * @function clearLineToCursor Clears lineToMouseRenderer baseLinesRenderer
   * @memberOf FollowmeMap
   */
  clearLineToCursor() {
    this.lineToMouseRenderer.clearContainer();
  }

  /**
   * @function clearActionHistory Deletes action history from map obj
   * @memberOf FollowmeMap
   */
  clearActionHistory() {
    this.undoStates = [];
    this.redoStates = [];
  }

  /**
   * @function selectNextDot Selects next dot
   * @memberOf FollowmeMap
   */
  selectNextDot() {
    let i;
    let targetDotIndex;
    let moveStep = 1;
    let selectedDots = [];
    const lastSelectedDot = this.selectedDots[this.selectedDots.length - 1];
    const changedDots = this.selectedDots.concat(lastSelectedDot + moveStep);

    if (this.moving) return;
    this.saveMapState();

    if (this.keysPressed[this.shiftKeyCode]) {
      targetDotIndex = lastSelectedDot + moveStep;
      if (this.mapDots.getByIndex(targetDotIndex)) this.selectedDots.push(targetDotIndex);
      this.redrawPartly(changedDots);
      return;
    }

    if (this.keysPressed[this.caterpillarBigMoveKeyCode] === true) {
      moveStep = 10;
      changedDots.push(lastSelectedDot + moveStep);
    }

    for (i = 0; i < this.selectedDots.length; i += 1) {
      targetDotIndex = this.selectedDots[i] + moveStep;
      if (this.mapDots.getByIndex(targetDotIndex)) selectedDots.push(targetDotIndex);
    }

    if (selectedDots.length === 0) selectedDots = [this.mapDots.getTotal() - 1];

    this.selectedDots = selectedDots;
    this.redrawPartly(changedDots);
  }

  /**
   * @function selectPreviousDot Selects previous dot
   * @memberOf FollowmeMap
   */
  selectPreviousDot() {
    let i;
    let targetDotIndex;
    let selectedDots = [];
    let moveStep = 1;
    const changedDots = this.selectedDots.concat(this.selectedDots[0] - moveStep);

    if (this.moving) return;
    this.saveMapState();

    if (this.keysPressed[this.shiftKeyCode]) {
      targetDotIndex = this.selectedDots[0] - moveStep;
      if (this.mapDots.getByIndex(targetDotIndex)) this.selectedDots.unshift(targetDotIndex);
      this.redrawPartly(changedDots);
      return;
    }

    if (this.keysPressed[this.caterpillarBigMoveKeyCode] === true) {
      moveStep = 10;
      changedDots.push(this.selectedDots[0] - moveStep);
    }

    for (i = 0; i < this.selectedDots.length; i += 1) {
      targetDotIndex = this.selectedDots[i] - moveStep;
      if (this.mapDots.getByIndex(targetDotIndex)) selectedDots.push(targetDotIndex);
    }

    if (selectedDots.length === 0) selectedDots = [0];

    this.selectedDots = selectedDots;
    this.redrawPartly(changedDots);
  }

  /**
   * @function traceControlsKeys Traces controls keys down/up. Used for selection manipulation
   * @memberOf FollowmeMap
   */
  traceControlsKeys() {
    let self = this;
    document.addEventListener('keydown', (ev) => {
      self.keysPressed[ev.keyCode] = true;
    });

    document.addEventListener('keyup', (ev) => {
      delete self.keysPressed[ev.keyCode];
    });
  }

  /**
   * @function setEvents Saves events data
   * @memberOf FollowmeMap
   * @param events
   */
  setEvents(events) {
    let i;
    this.events = {};
    for (i = 0; i < events.length; i += 1) {
      this.events[events[i].id] = events[i];
    }
  }

  /**
   * @function clearEvents Clears events renderer
   * @memberOf FollowmeMap
   */
  clearEvents() {
    this.map.getOverlayManager().removeLayer(this.EVENT_MARKER_LAYOUT);
  }

  /**
   * @function clearInstructions Clears instructions layer
   * @memberOf FollowmeMap
   */
  clearInstructions() {
    this.map.getOverlayManager().removeLayer(this.INSTRUCTIONS_LAYOUT);
  }

  /**
   * @function clearTracks Clears track renderer
   * @memberOf FollowmeMap
   */
  clearTracks() {
    this.baseLinesRenderer.clearContainer();
    this.map.getOverlayManager().removeLayer(this.MARKER_LAYOUT);
  }

  /**
   * @function clearRoute Clears route renderer
   * @memberOf FollowmeMap
   */
  clearRoute() {
    this.routeRenderer.clearContainer();
    this.map.getOverlayManager().removeLayer(this.ROUTE_LAYOUT);
  }

  /**
   * @function renderRoute Renders calculated route of track
   * @memberOf FollowmeMap
   * @param {Object} routeData Response from calculatePostedRoute
   */
  renderRoute(routeData) {
    let i;
    let j;
    const coordinates = [];
    const coordinatesWithColor = {};
    const impracticableCoordinates = [];
    let features;
    let marker;

    const translator = new InstructionsTranslator(i18next.languages[0]);

    if (!routeData || !routeData.features) return;

    features = routeData.features;

    this.routeData = routeData;
    this.clearRoute();

    let instructionIndex = 0;

    for (i = 0; i < features.length; i += 1) {
      const feature = features[i];

      switch (feature.geometry.type) {
        case 'LineString': {
          if (!this.showRoute) break;
          let isSpecialCase = false;

          let specialCaseCoordinates = [];
          if ('TYPE' in feature.properties && feature.properties.TYPE === 'ConnectError') {
            isSpecialCase = true;
          }

          for (j = 0; j < feature.geometry.coordinates.length; j += 1) {
            const segment = new window.IWCoordinate(
              feature.geometry.coordinates[j][0],
              feature.geometry.coordinates[j][1]
            );

            if (isSpecialCase) {
              specialCaseCoordinates.push(segment);
            } else {

              if(!coordinatesWithColor[feature.properties.COLOR]) coordinatesWithColor[feature.properties.COLOR] = {};

              if(!coordinatesWithColor[feature.properties.COLOR][i]) coordinatesWithColor[feature.properties.COLOR][i] = [];

              coordinatesWithColor[feature.properties.COLOR][i].push(segment);
              coordinates.push(segment);
            }
          }

          if (isSpecialCase) {
            impracticableCoordinates.push(specialCaseCoordinates);
          }

          break;
        }
        case 'Point': {
          if (!this.showRoute || !feature.properties || !(feature.properties.TEXT || feature.properties.ICONNAME)) break;

          if (feature.properties.TEXT) {
            instructionIndex++;

            marker = this.createRouteInstructionMarker(
              new window.IWCoordinate(
                feature.geometry.coordinates[0],
                feature.geometry.coordinates[1]
              ),
              instructionIndex + ': ' + translator.getTranslationForText(feature.properties.TEXT)
            );
          }

          if (feature.properties.ICONNAME) {
            marker = this.createRouteIconMarker(
              new window.IWCoordinate(
                feature.geometry.coordinates[0],
                feature.geometry.coordinates[1]
              ),
              feature.properties.ICONNAME
            );
          }

          this.map.getOverlayManager().getLayer(this.INSTRUCTIONS_LAYOUT).addOverlay(marker);
          break;
        }
        default:
          console.warn('Unsupported geometry type');
          break;
      }
    }

    this.map.getOverlayManager().getLayer(this.INSTRUCTIONS_LAYOUT).setVisible(this.showRouteInstructions);

    this.routeRenderer.drawPolyline(coordinates, this.pathStyles.default.background);
    //this.routeRenderer.drawPolyline(coordinates, this.pathStyles.default.main);
    Object.keys(coordinatesWithColor).forEach(key => {

      Object.keys(coordinatesWithColor[key]).forEach(index => {

        if(key === '#ffffff00' || key === 'route') {
          this.routeRenderer.drawPolyline(coordinatesWithColor[key][index], this.pathStyles.default.main);
        } else if(key === 'ccTransfer') {
          let options = {
            stroke: '#ffff00', strokeWidth: 5, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
          };
          this.routeRenderer.drawPolyline(coordinatesWithColor[key][index], options);
        }
        else {
          let options = {
            stroke: key, strokeWidth: 5, strokeOpacity: 1, strokeLinejoin: 'round', strokeLinecap: 'round'
          };
          this.routeRenderer.drawPolyline(coordinatesWithColor[key][index], options);
        }
      })
    });

    //this.routeRenderer.drawPolyline(coordinates, this.pathStyles.default.main);

    if (impracticableCoordinates.length > 0) {
      impracticableCoordinates.forEach((impracticableCoordinate) => {
        this.routeRenderer.drawPolyline(impracticableCoordinate, this.pathStyles.ConnectError.background);
        this.routeRenderer.drawPolyline(impracticableCoordinate, this.pathStyles.ConnectError.main);
      });
    }

    this.routeRenderer.render();
  }


  /**
   * @function removeTargetMarker Removes target overlay from target layer
   * @memberOf FollowmeMap
   * @param {int} layerId
   * @param {int} overlayId
   */
  removeTargetMarker(layerId, overlayId) {
    const layer = this.map.getOverlayManager().getLayer(layerId);
    let overlay;
    if (!layer || !layer.getOverlayById(overlayId)) return;

    overlay = layer.getOverlayById(overlayId);

    if (!overlay) return;

    layer.removeOverlay(overlay);
  }

  /**
   * @function isDefaultMarker Returns true if target index around selected dot
   * @memberOf FollowmeMap
   * @param {int} index
   * @returns {boolean} Is default marker
   */
  isDefaultMarker(index) {
    let i;
    if (this.selectedDots.indexOf(index) !== -1) return false;
    for (i = 0; i < this.selectedDots.length; i += 1) {
      if (index >= this.selectedDots[i] - 10 && index <= this.selectedDots[i] + 3) return true;
    }
    return false;
  }

  /**
   * @function redrawMarker Deletes previous dot marker and draws new
   * @memberOf FollowmeMap
   * @param {int} i Dot index
   * @param {boolean} forcedRotate Is marker needs to be rotated to next dot
   * @param {string} color Is marker needs to be rotated to next dot
   */
  redrawMarker(i, forcedRotate, color) {
    let angle;
    let marker;
    let markerType;
    const dot = this.mapDots.getByIndex(i);
    const id = '_' + Math.random().toString(36).substr(2, 9);

    if (this.mapDots.getTotalVisible() === 1) {
      marker = this.createCircleMarker(dot, color);
    } else if (this.selectedDots.indexOf(i) !== -1) {
      marker = this.createBigMarker(dot, color);
      markerType = 'big';
    } else if (this.isDefaultMarker(i) && this.selectedDots.length === 1) {
      marker = this.createDefaultMarker(dot, color);
      markerType = 'default';
    } else {
      marker = this.createSmallGreyMarker(dot);
      markerType = 'small';
    }

    marker.setId(id);

    this.map.getOverlayManager().getLayer(this.MARKER_LAYOUT).addOverlay(marker);

    let showEvent = !window.followmeMap.showAllEvents ? this.selectedDots.includes(i) : true;

    if (dot.hasEvent() && dot.getEvent().getIsDrawable() && showEvent) {
      const markerEvent = this.createEventMarker(dot.getCoordinate(), dot.getEvent(), markerType, i);

      markerEvent.setId(id);
      markerEvent.setCoordinate(dot.getCoordinate());

      this.map.getOverlayManager().getLayer(this.EVENT_MARKER_LAYOUT).addOverlay(markerEvent);

      dot.setMarkerEvent(markerEvent);
    } else {
      delete dot.clearMarkerEvent();
    }
    const previousDot = this.mapDots.getByIndex(i - 1);

    if (previousDot && previousDot.hasMarker()) {
      angle = FollowmeMap.getAngle(previousDot.getCoordinate(), dot.getCoordinate());
      previousDot.getMarker().setRotation(angle);
      previousDot.getMarker().redraw();
    }

    if (forcedRotate) {
      if (this.mapDots.getByIndex(i + 1)) {
        angle = FollowmeMap.getAngle(dot.getCoordinate(), this.mapDots.getByIndex(i + 1).getCoordinate());
      }
      if (this.mapDots.getTotalVisible() > 1) marker.setRotation(angle);

      marker.redraw();
    }

    if (this.editingMode) {
      marker.getContainer().style['pointer-events'] = 'none';
      if (dot.hasMarkerEvent()) dot.getMarkerEvent().getContainer().style['pointer-events'] = 'none';
    }

    dot.setMarker(marker);
  }

  /**
   * @function getAffectedDots Returns array of affected dots. Dots around changed
   * @memberOf FollowmeMap
   * @param {Array} changedDots
   * @returns {int[]}
   */
  getAffectedDots(changedDots) {
    let i;
    let map = {};
    changedDots = changedDots.map((d) => {
      return parseInt(d, 10);
    });
    return changedDots.reduce((array, dot) => {
      for (i = dot - 11; i <= dot + 3; i += 1) {
        if (map[i] || i < 0) continue;
        map[i] = true;
        array.push(i);
      }
      return array;
    }, []).sort((a, b) => {
      return a - b;
    });
  }

  /**
   * @function deleteDotMarkers Deletes event marker and dot marker for dot
   * @memberOf FollowmeMap
   * @param {Dot} dot
   */
  deleteDotMarkers(dot) {
    if (!dot) return;
    if (dot.hasMarkerEvent()) this.removeTargetMarker(this.EVENT_MARKER_LAYOUT, dot.getMarkerEvent().getId());
    if (dot.hasMarker()) this.removeTargetMarker(this.MARKER_LAYOUT, dot.getMarker().getId());

    dot.clearMarker();
    dot.clearMarkerEvent();
  }

  /**
   * @function Deletes markers of target dots
   * @memberOf FollowmeMap
   * @param {int[]} affectedDots
   */
  clearTargetDots(affectedDots) {
    let j;
    let i;
    for (j = 0; j < affectedDots.length; j += 1) {
      i = affectedDots[j];
      if (this.mapDots.getByIndex(i)) this.deleteDotMarkers(this.mapDots.getByIndex(i));
    }
  }

  /**
   * Deletes track markers and redraws base lines
   * @param {string} trackName
   */
  eraseTrack(trackName) {
    if (!this.editingTracks[trackName]) return;
    this.editingTracks[trackName].dots._dots.map(this.deleteDotMarkers.bind(this));
    delete this.editingTracks[trackName];

    this.redrawStaticTracksLines();
  }

  /**
   * Changes track makers pointer to a new name
   * @param {string} oldName
   * @param {String} newName
   */
  updateTrackName(oldName, newName) {
    const trackRender = this.editingTracks[oldName];
    if (!trackRender) throw new Error('Track with name ' + oldName + ' is not under edit');
    delete this.editingTracks[oldName];
    this.editingTracks[newName] = trackRender;
  }

  /**
   * Redraws lines for not editing tracks
   */
  redrawStaticTracksLines() {
    const currentTrackName = window.storage.getTrackInfo().trackName;
    Object.keys(followmeMap.editingTracks).forEach((tn) => {
      if (tn === currentTrackName) return;
      this.staticTrackLines = this.redrawBaseLines(this.editingTracks[tn].dots, this.baseLinesRenderer);
    });
  }

  /**
   * @function Redraws changed dots in current track
   * @memberOf FollowmeMap
   * @param {int[]} changedDots
   * @param {string} color Marker colors
   */
  redrawPartly(changedDots, color) {
    this.drawing = true;

    if (!color) {
      if (window.storage.isTestMode()) {
        color = window.storage.getTestTrack().color;
      } else {
        color = window.storage.getTrackInfo().color;
      }
    }

    const affectedDots = this.getAffectedDots(changedDots);
    this.clearTargetDots(affectedDots);

    this.mapDots.get().forEach((dot, index) => {
      if (!dot.isDrawable() || (dot.hasMarker() && affectedDots.indexOf(index) === -1)) return;

      const nextIndex = index + 1;
      const forceRotate = nextIndex !== affectedDots[nextIndex] || !this.mapDots.getByIndex(nextIndex);

      this.redrawMarker(index, forceRotate, color);
    });

    this.makeTrackDotsActive(affectedDots);
    this.staticTrackLines = this.redrawBaseLines(this.mapDots, this.baseLinesRenderer, true);
    this.updateDotIndexes(this.mapDots);

    if (!this.showTrack) this.toggleTrackDisplay();

    this.drawing = false;
  }

  /**
   * @function disableMarkersPointerEvents Disables markers pointer events
   * @memberOf FollowmeMap
   * @param {Boolean} [forced] If not forced and already in editing mode method will not be applied
   */
  disableMarkersPointerEvents(forced) {
    let i;
    let overlays;

    if (this.editingMode && !forced) return;
    this.editingMode = true;

    overlays = this.map.getOverlayManager().getLayer(this.MARKER_LAYOUT).getOverlays()
      .concat(this.map.getOverlayManager().getLayer(this.EVENT_MARKER_LAYOUT).getOverlays());
    for (i = 0; i < overlays.length; i += 1) {
      overlays[i].getContainer().style['pointer-events'] = 'none';
    }
  }

  /**
   * @function enableMarkersPointerEvents Enables pointer events for markers
   * @memberOf FollowmeMap
   */
  enableMarkersPointerEvents() {
    let i;
    let overlays;

    this.editingMode = false;

    overlays = this.map.getOverlayManager().getLayer(this.MARKER_LAYOUT).getOverlays()
      .concat(this.map.getOverlayManager().getLayer(this.EVENT_MARKER_LAYOUT).getOverlays());
    for (i = 0; i < overlays.length; i += 1) {
      overlays[i].getContainer().style['pointer-events'] = 'all';
    }
  }

  /**
   * Restores the track based on a plain text object representation
   *
   * @param {Array} rawDots
   * @param {String} color Color for makers
   * @return {Dots} track dots
   */
  restoreTrack(rawDots, color) {
    let dots;

    if (rawDots.constructor.name === 'Dots') {
      dots = rawDots;
    } else {
      dots = new Dots();

      rawDots.forEach((dot) => {
        dots.add(FollowMeMapUtils.restoreDot(dot));
      });
    }

    this.setDots(dots);

    this.renderTrack(color);
    this.zoomToBounds();

    return dots;
  }

  /**
   * Formula for bearing on a rhumb line (https://en.wikipedia.org/wiki/Rhumb_line):
   *
   * Δψ = ln( tan(π/4 + φ2/2) / tan(π/4 + φ1/2) ) ----> ("projected" latitude difference)
   * θ = atan2(Δλ, Δψ)
   * - where φ is latitude, λ is longitude, Δλ is taking shortest route (<180°), R is the earth’s radius, ln is natural log
   *
   * @param cord1
   * @param cord2
   * @returns {number}
   * @static
   */
  static getAngle(cord1, cord2) {
    const toRadians = (value) => {
      return (value * Math.PI) / 180;
    };

    const toDegrees = (radians) => {
      return (radians * 180) / Math.PI;
    };

    const pointA = cord1.toWGS84();
    const pointB = cord2.toWGS84();

    let delta = toRadians((pointB.getX() - pointA.getX()));
    let log;
    let theta;

    // if delta over 180° take shorter rhumb line across the anti-meridian
    if (delta > Math.PI) delta -= 2 * Math.PI;
    if (delta < -Math.PI) delta += 2 * Math.PI;

    log = Math.log(Math.tan((toRadians(pointB.getY()) / 2) + (Math.PI / 4)) /
      Math.tan((toRadians(pointA.getY()) / 2) + (Math.PI / 4)));

    theta = Math.atan2(delta, log);

    return (toDegrees(theta) + 360) % 360;
  }

  /**
   * Updates an event on the map after the user has modified it inline
   *
   * @param {number} dotIndex
   * @param {number} eventId
   * @param {string} eventName
   * @param {string} eventDescription
   * @param {string} eventColor
   *
   * @return {void}
   */
  updateInlineEvent(dotIndex, eventId, eventName, eventDescription, eventColor) {
    this.saveMapState();

    const dot = this.mapDots.getByIndex(dotIndex);
    const oldEvent = dot.getEvent();

    dot.setEvent(new Event(oldEvent.getId(), eventName, eventDescription, eventColor, oldEvent.getIsDefault(), true));

    this.saveTrackDots();
    this.redrawPartly([dotIndex]);
  }

  /**
   * Retrieves a list of events definitions, if any
   *
   * @return {Object}
   */
  getEventCustomDefinition() {
    return this.mapDots.getDefinitions();
  }

  getEventCustomLabel(event) {
    let label = event.getName();
    const content = event.getContent();

    Object.keys(content).forEach((item) => {
      if (!(item in content) || content[item] === null) return;
      label += '<small><strong>' + getCustomEventAttribute(item) + '</strong>: ' + content[item] + '</small>';
    });

    return label;
  }

  /**
   * Iterates through each of the dots with events and checks if the event is present on at least one dot
   *
   * @param eventId
   */
  dotHasCustomEventAssigned(eventId) {
    return this.mapDots.get().some((dot) => {
      if (!dot.hasEvent() || dot.getEvent().constructor.name !== 'EventCustom') return false;

      return dot.getEvent().getId() === eventId;
    });
  }

  /**
   * Creates general IWClassMarker
   * @param coordinates
   * @param {string} label
   * @param {string} color
   * @param {string} classes Classes to add to marker element
   * @returns {window.IWClassMarker}
   */
  createGeneralMarker(coordinates, label, color, classes) {
    classes = classes || '';
    const marker = new window.IWClassMarker(this.map, coordinates.toMercator(), 'dot-event ' + classes, label, color);
    const markerElement = $(marker)[0];

    this.enableMarkerZoomActions(marker);
    marker.setContainerClassname('dot-event ' + classes);

    markerElement._label.style.borderLeft = '4px solid ' + color;
    markerElement._label.style.top = 'auto';
    markerElement._label.style.bottom = '14px';

    return marker;
  }

  /**
   * @function createRouteRemarkMarker
   * @memberOf FollowmeMap
   * @param {window.IWCoordinate} coordinates
   * @param {string} label Label to display
   * @returns {window.IWClassMarker}
   */
  createRouteRemarkMarker(coordinates, label) {
    return this.createGeneralMarker(coordinates, label, 'white', 'dot-remark');
  }

  /**
   * @function createSearchMarker
   * @memberOf FollowmeMap
   * @param {window.IWCoordinate} coordinates
   * @param {string} label Label to display
   * @returns {window.IWClassMarker}
   */
  renderSearchMarker(coordinates, label) {
    const marker = this.createGeneralMarker(coordinates, label, 'white', 'dot-search');

    this.map.getOverlayManager().removeLayer(this.SEARCH_MARKERS_LAYOUT);
    this.map.getOverlayManager().getLayer(this.SEARCH_MARKERS_LAYOUT).addOverlay(marker);
  }

  /**
   * Removes search markers layer
   */
  clearSearchMarkers() {
    this.map.getOverlayManager().removeLayer(this.SEARCH_MARKERS_LAYOUT);
  }

  /**
   * Sets and renders status and remarks, considering current visibility state
   * @param statusAndRemarks
   */
  restoreStatusAndRemarks(statusAndRemarks) {
    this.setTrackStatusAndRemarks(statusAndRemarks);

    this.renderStatusAndRemarks(statusAndRemarks, true);

    this.updateStatusAndRemarksDisplay();
  }

  /**
   * Renders status and remarks
   * @param {object} statusAndRemarks
   * @param {object} statusAndRemarks.remarks
   * @param {object} statusAndRemarks.status
   * @param {boolean} forced Force render
   */
  renderStatusAndRemarks(statusAndRemarks, forced) {
    statusAndRemarks = statusAndRemarks || this.statusAndRemarks;
    if (!forced && (!this.showStatusAndRemarks || !statusAndRemarks)) return;

    this.clearStatusAndRemarksLayout();

    this.renderRemarks(statusAndRemarks.remarks);
    this.renderStatus(statusAndRemarks.status);
  }

  /**
   * @function createDayEventMarker
   * @memberOf FollowmeMap
   * @param {DayEvent} dayEvent
   * @returns {window.IWClassMarker}
   */
  createDayEventMarker(dayEvent) {
    const marker = this.createGeneralMarker(dayEvent.coordinates, dayEvent.name, 'white', 'dot-day-event');
    const markerElement = $(marker)[0];
    let availabilityText = 'Always';

    window.enableContextMenu(window.createDayEventsContextMenu.bind(null, dayEvent.name), $(marker.getContainer()));

    switch (dayEvent.type) {
      case 'dayofweek': {
        availabilityText = dayEvent.weekday;
        break;
      }
      case 'fromto': {
        availabilityText = 'FROM ' + formatDayEventDate(dayEvent.fromDate)
          + ' TO ' + formatDayEventDate(dayEvent.toDate);
        break;
      }
      default:
        break;
    }

    const labelContent = '<div>' + dayEvent.name + '</div>' +
      '<div class="fontsize-x-small availability">' + availabilityText + '</div>';

    const labelElement = $(markerElement._label);
    labelElement.html(labelContent);
    labelElement.find('div ').attr('title', dayEvent.name);

    return marker;
  }

  /**
   * @function createRouteRemarkMarker
   * @memberOf FollowmeMap
   * @param {window.IWCoordinate} coordinates
   * @param {string} label Label to display
   * @returns {window.IWClassMarker}
   */
  createStatusMarker(coordinates, label) {
    return this.createGeneralMarker(coordinates, label, '#0004ff', 'dot-status-marker');
  }

  renderDayEvent(dayEvent) {
    const marker = this.createDayEventMarker(dayEvent);
    this.map.getOverlayManager().getLayer(this.DAY_EVENTS_LAYOUT).addOverlay(marker);
  }

  clearDayEvents() {
    this.map.getOverlayManager().removeLayer(this.DAY_EVENTS_LAYOUT);
  }

  renderDayEvents(dayEvents) {
    dayEvents = dayEvents || this.dayEvents;
    this.clearDayEvents();
    dayEvents.map(this.renderDayEvent.bind(this));
  }

  setDayEvents(dayEvents) {
    this.dayEvents = dayEvents;
  }

  addDayEvent(dayEvent) {
    this.dayEvents.push(dayEvent);
    this.renderDayEvent(dayEvent);
  }

  renderRemarks(pathData) {
    if (!this.showStatusAndRemarks || !pathData || !pathData.features) return;

    let i;
    let features;
    let marker;

    features = pathData.features;

    for (i = 0; i < features.length; i += 1) {
      const feature = features[i];

      switch (feature.geometry.type) {
        case 'Point': {
          if (!feature.properties || !feature.properties.TEXT) break;

          const label = feature.properties.TEXT;
          marker = this.createRouteRemarkMarker(
            new window.IWCoordinate(
              feature.geometry.coordinates[0],
              feature.geometry.coordinates[1]
            ),
            label
          );

          this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).addOverlay(marker);
          break;
        }
        default:
          console.warn('Unsupported geometry type');
          break;
      }
    }

    this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).setVisible(this.showStatusAndRemarks);
  }

  highlightLiveViewRoute(trackName) {
    const polylines = this.liveViewPolylines[trackName];
    if (typeof polylines === 'undefined') return;
    this.currentHighlightedTrack = trackName;
    polylines.forEach((polyline) => {
      polyline.attributes.strokeWidth = 7;
    });
    this.statusAndRemarksRenderer.render();
  }

  removeHighlightFromLiveViewRoute(trackName) {
    const polylines = this.liveViewPolylines[trackName];
    this.currentHighlightedTrack = 'no-track';
    if (typeof polylines === 'undefined') return;
    polylines.forEach((polyline) => {
      polyline.attributes.strokeWidth = 3;
    });
    this.statusAndRemarksRenderer.render();
  }

  deleteLiveViewPolyline(trackName) {
    const polylines = this.liveViewPolylines[trackName];
    const renderer = this.statusAndRemarksRenderer;
    const marker = this.liveViewMarker[trackName];

    polylines.forEach((polyline) => {
      renderer.removeElement(polyline);
    });
    this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).removeOverlay(marker);

    delete this.liveViewPolylines[trackName];

    renderer.render();
  }

  renderStatusForLiveView(pathData, trackName) {
    let i;
    let j;
    let features;
    const path = [];
    const renderer = this.statusAndRemarksRenderer;
    const styles = this.liveViewPathStyles;
    if (!pathData || !pathData.features || !this.showStatusAndRemarks) return;

    features = pathData.features;

    // renderer.clearContainer();

    for (i = 0; i < features.length; i += 1) {
      const feature = features[i];
      const segment = { type: feature.properties.TYPE || 'default', coordinates: [] };

      switch (feature.geometry.type) {
        case 'LineString':
          for (j = 0; j < feature.geometry.coordinates.length; j += 1) {
            const point = new window.IWCoordinate(
              feature.geometry.coordinates[j][0],
              feature.geometry.coordinates[j][1]
            );
            segment.coordinates.push(point);
          }
          break;
        case 'Point': {
          if (!feature.properties || !feature.properties.STATE) break;

          // if(feature.properties.STATE === "finished") removeLiveSpanFromTrackList(trackName);

          const icon = new IWIcon('./img/icons/car-top.svg', new window.IWPoint(10, 18), new window.IWSize(20, 36));
          const marker = new IWMarker(this.map, new window.IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1]));
          marker.setDefaultIcon(icon);

          this.liveViewMarker[trackName] = marker;
          this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).addOverlay(marker);
          break;
        }
        default:
          console.debug('Unsupported geometry type');
          break;
      }
      path.push(segment);
    }

    let polylines = [];
    const doneSegements = [];
    const todoSegments = [];


    const keys = Object.keys(path);
    for (i = keys.length - 1; i >= 0; i--) {
      const segment = path[i];

      const style = styles[segment.type] || styles.default;

      if (segment.type === 'done') {
        doneSegements.push(segment);
      } else {
        todoSegments.push(segment);
      }

      // polylines.push(renderer.drawPolyline(segment.coordinates, style.background));
      // polylines.push(renderer.drawPolyline(segment.coordinates, style.main));
    }

    polylines = this.renderDoneStatusLiveView(doneSegements, renderer).concat(this.renderTodoStatusLiveView(todoSegments, renderer));

    this.liveViewPolylines[trackName] = polylines;

    renderer.render();
  }

  renderDoneStatusLiveView(segments, renderer) {
    const polylines = [];
    const styles = this.liveViewPathStyles;
    segments.forEach((segment) => {
      const style = styles[segment.type] || styles.default;

      polylines.push(renderer.drawPolyline(segment.coordinates, style.background));
      polylines.push(renderer.drawPolyline(segment.coordinates, style.main));
    });
    return polylines;
  }

  renderTodoStatusLiveView(segments, renderer) {
    const polylines = [];
    const styles = this.liveViewPathStyles;
    segments.forEach((segment) => {
      const style = styles[segment.type] || styles.default;
      polylines.push(renderer.drawPolyline(segment.coordinates, style.background));
      polylines.push(renderer.drawPolyline(segment.coordinates, style.main));
    });
    return polylines;
  }

  renderStatus(pathData) {
    let i;
    let j;
    let features;
    let path = [];
    const renderer = this.statusAndRemarksRenderer;
    const styles = this.pathStyles;

    if (!pathData || !pathData.features || !this.showStatusAndRemarks) return;

    features = pathData.features;

    renderer.clearContainer();

    for (i = 0; i < features.length; i += 1) {
      const feature = features[i];
      const segment = { type: feature.properties.TYPE || 'default', coordinates: [] };

      switch (feature.geometry.type) {
        case 'LineString':
          for (j = 0; j < feature.geometry.coordinates.length; j += 1) {
            const point = new window.IWCoordinate(
              feature.geometry.coordinates[j][0],
              feature.geometry.coordinates[j][1]
            );
            segment.coordinates.push(point);
          }
          break;
        case 'Point': {
          if (!feature.properties || !feature.properties.STATE) break;

          const marker = this.createStatusMarker(
            new window.IWCoordinate(
              feature.geometry.coordinates[0],
              feature.geometry.coordinates[1]
            ),
            feature.properties.STATE
          );

          this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).addOverlay(marker);
          break;
        }
        default:
          console.debug('Unsupported geometry type');
          break;
      }
      path.push(segment);
    }
    window.statusBGPolyline = [];
    window.statusPolyline = [];
    const keys = Object.keys(path);
    for (i = keys.length - 1; i >= 0; i--) {
      const segment = path[i];
      const style = styles[segment.type] || styles.default;
      window.statusBGPolyline.push(renderer.drawPolyline(segment.coordinates, style.background));
      window.statusPolyline.push(renderer.drawPolyline(segment.coordinates, style.main));
    }

    renderer.render();
  }

  buildDotTable() {
    window.tableSettings = window.storage.getTableSettings();
    let tableContainer = $('#dot-table');
    let currentMod = window.storage.getFollowMeMod();

    if (tableSettings.showTable && tableSettings.showTable !== undefined) {
      tableContainer.removeClass('d-none');
    } else {
      tableContainer.addClass('d-none');
      return;
    }

    let dots = this.getRawTrackDots();
    window.customEventKeys = Object.keys(customEventsAttributes);

    let table = $('<div class="table">');
    let header = $('#dot-table-header');
    let body = $('#dot-table-body');

    body.empty();

    let usedCustomEventAttributes = [];

    dots.forEach(dot => {
      if (dot.event && dot.event.constructor.name === 'EventCustom') {
        usedCustomEventAttributes = usedCustomEventAttributes.concat(Object.keys(dot.event._content));
      }
    });
    window.customEventKeys = customEventKeys.filter(key => usedCustomEventAttributes.includes(key));

    header.find('.custom-event-header').each((i, ele) => {
      $(ele).remove();
    });

    window.customEventKeys.forEach(key => {
      if (!$(`#dot-table-header-${key}`).length) {
        let eventHeader = $(`<th class="custom-event-header" id="dot-table-header-${key}">${customEventsAttributes[key].name}</th>`);
        header.append(eventHeader);
      }
    });

    window.defaultEventSelect = $('<select onchange="followmeMap.defaultEventChanged(this, this.value)" data-eventtype="default" class="custom-field-select">' +
      '<option value="-1">---</option></select>');

    defaultEvents.forEach((event) => {

      if(window.CONSTANTS.DYNAMIC_DEFAULT_EVENTS.includes(event.id)) {
        defaultEventSelect.append($(`<option value="${event.id}" data-translation-key="${CONSTANTS.DEFAULT_EVENT_KEYS_MOD[currentMod][event.id]}"></option>`));
      } else {
        defaultEventSelect.append($(`<option value="${event.id}" data-translation-key="${CONSTANTS.DEFAULT_EVENT_TRANSLATION_MAP[event.id]}"></option>`));
      }

    });

    dots.forEach((dot, i) => {
      this.addRowToDotTable(dot, i, body);
    });

    this.hideDisabledCells();

    this.highlightTableRows(this.selectedDots);
    window.translateTableElements();
  }

  customEventValueChanged(row, value, type) {
    let dot = this.mapDots.getByIndex(row);
    if (dot._event) {
      dot._event._content[type] = value;
      this.saveTrackDots();
      this.redrawPartly([row]);
    } else {
      let foundDefinition;

      window.storage.getCustomEventDefinitions().forEach(def => {
        if (def._definition.properties[type]) {
          foundDefinition = def;
        }
      });

      if (foundDefinition) {
        let content = {};
        content[type] = value;

        Object.keys(foundDefinition._definition.properties).forEach(prop => {
          if (!content[prop]) {
            content[prop] = '';
          }
        });

        dot.setEventFromTable(new EventCustom(
          parseInt(foundDefinition._definition.code, 10),
          foundDefinition._definition.title,
          content,
          foundDefinition._color,
          true
        ));

        this.saveTrackDots();
        this.redrawPartly([row]);
      }
    }
    // this.lastChangedEvent = dot._event;
  }

  textEventValueChanged(row, value) {
    let dot = this.mapDots.getByIndex(row);
    if (dot._event) {
      dot._event._name = value;
    } else {
      let newEvent = new Event(
        1,
        value,
        '',
        '#6766bf',
        false,
        true
      );
      dot.setEventFromTable(newEvent);
    }

    this.saveTrackDots();
    this.redrawPartly([row]);
  }

  defaultEventChanged(ele, value) {
    let dotIndex = $(ele).parent().data('row-index');
    if (value > 0) {
      this.assignEventToDots(value, dotIndex);
    } else {
      this.removeEventFromDot(dotIndex);
    }
  }

  clearDotTable() {
    $('#dot-table-body').empty();
  }

  hideDotTable() {
    this.clearDotTable();
    $('#dot-table').addClass('d-none');
    setMapFormat();
  }

  redrawDotTableRows() {
    let body = $('#dot-table-body');

    body.empty();

    if(this.getRawTrackDots().length === 0) return;

    this.getRawTrackDots().forEach((dot, i) => {
      this.addRowToDotTable(dot, i, body);
    });

    this.hideDisabledCells();
    this.highlightTableRows(this.selectedDots);
    window.translateTableElements();
  }

  hideDisabledCells() {
    Object.keys(tableSettings).forEach(settings => {
      let column = $(`#dot-table-header-${settings}`);
      if (column) {
        if (!tableSettings[settings]) {
          $(`.${settings}-cell`).each((i, ele) => {
            $(ele).addClass('d-none');
          });
          column.addClass('d-none');
        } else {
          column.removeClass('d-none');
        }
      }
    });
  }

  addRowToDotTable(dot, i, body) {
    let eventType;

    if (dot.event && dot.event._isDefault) {
      eventType = 'default';
    } else if (dot.event && dot.event.constructor.name === 'EventCustom') {
      eventType = 'custom';
    } else if (dot.event && !dot.event._isDefault) {
      eventType = 'text';
    }

    if (FollowmeMap.isTableRowHidden(tableSettings, eventType) && !this.selectedDots.includes(i)) return;

    let row = this.createDotTableRow(dot, i, eventType);

    row.click(e => {
      body.find('tr').each((i, tr) => {
        $(tr).removeClass('table-primary');
      });

      row.addClass('table-primary');
      let redrawDots = [];
      redrawDots.push(i);
      this.selectedDots.forEach(dot => {
        redrawDots.push(dot);
      });
      this.selectedDots = [i];
      this.redrawPartly(redrawDots);
      this.map.setCenter(this.mapDots.getByIndex(i).getCoordinate());
    });

    body.append(row);

    if (eventType === 'default') {
      let defaultEventSelector = $(`#default-event-selector-${i}`);
      defaultEventSelector.find('select').val(dot.event._id);

      if(dot.event._id === 65539) {
        defaultEventSelector.find(`[value=${dot.event._id}]`).data('translation-key', 'events.transfer');
      } else if(Object.keys(window.CONSTANTS.DEFAULT_EVENT_KEYS_MOD).includes(dot.event._name)) {
        defaultEventSelector.find(`[value=${dot.event._id}]`).data('translation-key', window.CONSTANTS.DEFAULT_EVENT_KEYS_MOD[dot.event._name][dot.event._id]);
      } else {
        defaultEventSelector.find(`[value=${dot.event._id}]`).data('translation-key', window.CONSTANTS.DEFAULT_EVENT_TRANSLATION_MAP[dot.event._id]);
      }

    } else if (eventType === 'text') {
      $(`#text-event-input-${i}`).val(dot.event._name);
    }

    this.disableTableInputs(i, eventType);

    row.find($(`#eventtype-${i}`)).on('change', (e, ele) => {
      let element = $(`#eventtype-${i}`);
      this.disableTableInputs(element.get(0).dataset.rowindex, element.val());
      this.removeEventFromDot(i);

      if (element.val() === 'custom' && this.lastChangedEvent) {
        let dot = this.mapDots.getByIndex(i);
        dot.setEventFromTable(this.lastChangedEvent);
        this.updateTableRow(i, dot);
      }
    });
  }

  createDotTableRow(dot, i, eventType) {
    let row = $('<tr id="dot-table-row-' + i + '"></tr>');

    row.append($(`<td class="index-cell">${i + 1}</td>`));
    row.append($(`<td class="coordinates-cell">${dot.lat.toString().slice(0, 10)}, ${dot.lon.toString().slice(0, 10)}</td>`));

    row.append($(`<td class="eventtype-cell">
              <select data-rowindex="${i}" id="eventtype-${i}" data-eventtype="allEvents" class="custom-field-select">
                    <option value="na" ${!eventType ? 'selected' : ''}>---</option>
                    <option value="default" ${eventType === 'default' ? 'selected' : ''} data-translation-key="event-table.default-event"></option>
                    <option value="text" ${eventType === 'text' ? 'selected' : ''} data-translation-key="sidebar.user-generated-events"></option>
                    <option class="custom-event-option" value="custom" ${eventType === 'custom' ? 'selected' : ''} data-translation-key="sidebar.custom-structure-events"></option>
              </select></td>`));

    if (customEventKeys.length <= 0) {
      row.find('.custom-event-option').addClass('d-none');
    }

    let defaultCell = $(`<td class="default-cell" data-row-index="${i}" id="default-event-selector-${i}">${defaultEventSelect.get(0).outerHTML}</td>`);

    row.append(defaultCell);
    row.append($(`<td class="text-cell"><input data-eventtype="text" onchange="followmeMap.textEventValueChanged(${i}, this.value)" class="custom-field-select" maxlength="50" type="text" id="text-event-input-${i}"></td>`));

    let usedCustomEvents = [];
    if (dot.event && dot.event._content) {
      usedCustomEvents = Object.keys(dot.event._content);
    }

    customEventKeys.forEach(key => {
      let eventAttr = customEventsAttributes[key];
      let value;
      if (usedCustomEvents.includes(key)) {
        value = dot.event._content[key];
      }

      switch (eventAttr.type) {
        case 'boolean': {
          let cell = $(`<td class="${key}-cell" id="${key}-${i}"><select onchange="followmeMap.customEventValueChanged(${i}, this.value, $(this).data('key'))" data-key="${key}" data-eventtype="custom" class="custom-field-select"><option value="undefined">---</option><option value="true" data-translation-key="events.yes"></option><option value="false" data-translation-key="events.no"></option></select></td>`);
          if (value === undefined) {
            cell.find('select').val('undefined');
          } else {
            cell.find('select').val(value.toString());
          }
          row.append(cell);
          break;
        }
        case 'integer':
          row.append($(`<td class="${key}-cell" id="${key}-${i}"><input onchange="followmeMap.customEventValueChanged(${i}, this.value, $(this).data('key'))" data-key="${key}" value="${value !== undefined ? value : ''}" data-eventtype="custom"  type="number" autocomplete="off" step="1" min="0" class="custom-field"></td>`));
          break;
        case 'float':
          row.append($(`<td class="${key}-cell" id="${key}-${i}"><input onchange="followmeMap.customEventValueChanged(${i}, this.value, $(this).data('key'))" data-key="${key}" value="${value !== undefined ? value : ''}" data-eventtype="custom"  type="number" autocomplete="off" min="0" step="0.01" class="custom-field"></td>`));
          break;
        case 'string':
          row.append($(`<td class="${key}-cell" id="${key}-${i}"><input onchange="followmeMap.customEventValueChanged(${i}, this.value, $(this).data('key'))" data-key="${key}" value="${value !== undefined ? value : ''}" data-eventtype="custom"  type="text" autocomplete="off" class="custom-field"></td>`));
          break;
        default:
          break;
      }
    });

    return row;
  }

  static isTableRowHidden(tableSettings, eventType) {
    if (!tableSettings.showEmpty && !eventType) {
      return true;
    }

    if (tableSettings[eventType] !== undefined && !tableSettings[eventType]) {
      return true;
    }

    return 0;
  }

  disableTableInputs(rowIndex, eventType) {
    let row = $(`#dot-table-row-${rowIndex}`);

    row.find('input').each((i, input) => {
      if (input.dataset.eventtype !== eventType && input.dataset.eventtype !== 'allEvents') {
        $(input).attr('disabled', true);
      } else {
        $(input).attr('disabled', false);
      }
    });
    row.find('select').each((i, select) => {
      if (select.dataset.eventtype !== eventType && select.dataset.eventtype !== 'allEvents') {
        $(select).attr('disabled', true);
      } else {
        $(select).attr('disabled', false);
      }
    });
  }

  highlightTableRows(selectedDots) {
    if (selectedDots.some(dot => dot < 0)) return;

    if (!$('#dot-table').is(':visible')) return;

    let rows = $('#dot-table-body').find('.table-primary');

    rows.each((i, tr) => {
      $(tr).removeClass('table-primary');
    });


    selectedDots.forEach(dotIndex => {
      $(`#dot-table-row-${dotIndex}`).addClass('table-primary');
    });

    let scrollTo = $(`#dot-table-row-${selectedDots[0]}`);

    if (scrollTo.get(0)) {
      scrollTo.get(0).scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      this.redrawDotTableRows();
    }
  }

  updateTableRow(rowIndex, dot) {
    let inputs = $(`#dot-table-row-${rowIndex}`).find('[data-key]');
    inputs.each((i, input) => {
      let key = $(input).data('key');
      if (dot._event._content[key]) {
        $(input).val(dot._event._content[key]);
      }
    });
  }

  toggleSelectPolygon() {
    this.selectPolygonActive = !this.selectPolygonActive;
    const lassoBtn = $('#lasso-select-btn');
    if(this.selectPolygonActive) {
      lassoBtn.parent().data('title-translation-key', 'editor.titles.disable-polygon-select');
      lassoBtn.addClass('inactive');
    } else {
      lassoBtn.parent().data('title-translation-key', 'editor.titles.enable-polygon-select');
      lassoBtn.removeClass('inactive');
    }
    window.translateElements();
    lassoBtn.parent().tooltip('hide');
    lassoBtn.parent().tooltip('show');
  }

  initHybrid() {
    const URL = 'https://wmts.geo.admin.ch/EPSG/3857/1.0.0/WMTSCapabilities.xml';

    let parser = new IWWMTSParser();
    parser.parse(URL, layers => {
      let layer = layers.find(it => it.id === 'ch.swisstopo.swissimage');
      this.swisstopoHybrid = IWWMTSUtils.createMapTypeFromWMTSLayer(this.map, layer);
      this.swisstopoHybrid.setName('swisstopo-hybrid');

      let copyright = this.map.getOptions().getMapTypeByName('tomtom-latest').getCopyright();
      copyright = copyright.slice(0, copyright.indexOf(',') + 2) + 'swisstopo, ' + copyright.slice(copyright.indexOf(',') + 2);
      this.swisstopoHybrid.setCopyright(copyright);

      let serverConfig = this.map.getOptions().getMapTypeByName('tomtom-latest').getTilesServerConfig();
      let streets = new IWStreetsPostProcessor(this.map, serverConfig);
      this.swisstopoHybrid.setPostProcessor(streets);

      this.map.setMapType(this.swisstopoHybrid);
    });
  }

  initAir() {
    const URL = 'https://wmts.geo.admin.ch/EPSG/3857/1.0.0/WMTSCapabilities.xml';

    let parser = new IWWMTSParser();
    parser.parse(URL, layers => {
      let layer = layers.find(it => it.id === 'ch.swisstopo.swissimage');
      this.swisstopoAir = IWWMTSUtils.createMapTypeFromWMTSLayer(this.map, layer);
      this.swisstopoAir.setName('swisstopo-air');

      let copyright = 'infoware, swisstopo';
      this.swisstopoAir.setCopyright(copyright);

      this.map.setMapType(this.swisstopoAir);
    });
  }

  setWMTSHybrid() {
    if (this.swisstopoHybrid) {
      this.map.setMapType(this.swisstopoHybrid);
    } else {
      this.initHybrid();
    }
  }

  setWMTSAir() {
    if (this.swisstopoAir) {
      this.map.setMapType(this.swisstopoAir);
    } else {
      this.initAir();
    }
  }
}

if (typeof window !== 'undefined') window.FollowmeMap = FollowmeMap;

module.exports = FollowmeMap;
